import React from 'react';
import { Users } from 'lucide-react';

const TeamAndRolesTab = ({ jobData, setJobData, allRoles, users }) => {

  const handleRoleToggle = (roleName) => {
    const currentRoles = jobData.assignedRoles || [];
    const newRoles = currentRoles.includes(roleName)
      ? currentRoles.filter(r => r !== roleName)
      : [...currentRoles, roleName];
    setJobData({ ...jobData, assignedRoles: newRoles });
  };

  const handleMemberToggle = (memberId) => {
    const currentMembers = jobData.assignedMembers || [];
    const newMembers = currentMembers.includes(memberId)
      ? currentMembers.filter(m => m !== memberId)
      : [...currentMembers, memberId];
    setJobData({ ...jobData, assignedMembers: newMembers });
  };

  const availableMembers = users.filter(user => 
    user.roles && user.roles.some(role => (jobData.assignedRoles || []).includes(role))
  );

  return (
    <div>
      <h3 className="text-lg font-semibold text-gray-800 mb-4 flex items-center">
        <Users className="mr-2" />
        Equipo y Roles Asignados
      </h3>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {/* Asignación de Roles */}
        <div>
          <h4 className="font-medium text-gray-700 mb-2">Roles Requeridos para el Job</h4>
          <div className="space-y-2 p-3 bg-gray-50 rounded-md border">
            {allRoles.map(role => (
              <label key={role} className="flex items-center space-x-3 cursor-pointer">
                <input
                  type="checkbox"
                  checked={(jobData.assignedRoles || []).includes(role)}
                  onChange={() => handleRoleToggle(role)}
                  className="h-4 w-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-500"
                />
                <span className="text-gray-700">{role}</span>
              </label>
            ))}
          </div>
        </div>

        {/* Asignación de Miembros */}
        <div>
          <h4 className="font-medium text-gray-700 mb-2">Miembros del Equipo Asignados</h4>
           <div className="space-y-2 p-3 bg-gray-50 rounded-md border max-h-48 overflow-y-auto">
            {availableMembers.length > 0 ? availableMembers.map(member => (
              <label key={member.uid} className="flex items-center space-x-3 cursor-pointer">
                <input
                  type="checkbox"
                  checked={(jobData.assignedMembers || []).includes(member.uid)}
                  onChange={() => handleMemberToggle(member.uid)}
                  className="h-4 w-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-500"
                />
                <span className="text-gray-700">{member.name || member.email}</span>
              </label>
            )) : <p className="text-sm text-gray-500">Selecciona un rol para ver los miembros disponibles.</p>}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TeamAndRolesTab;
